
    import '/Users/lijixiang/Work/power-design/site/docs/power-design/user-info.md?watch=parent';
    export const demoIndex = {
  ids: ["docs-power-design-user-info-demo-user-info","docs-power-design-user-info-demo-multiple"],
  getter: () => import(/* webpackChunkName: "meta__docs" */'/Users/lijixiang/Work/power-design/site/docs/power-design/user-info.md?type=demo')
};